import {Component, Inject, Input, OnInit} from '@angular/core';
import {NgxModalDraggableDirective} from '../../directives/draggable.directive';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {isMobile, log} from '../../functions';

@Component({
  selector: 'app-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss']
})
export class ModalHeaderComponent implements OnInit {
  @Input() expand = true;
  @Input() minimized = true;
  @Input() title: string;
  @Input() icon: string;
  @Input() modalDirective: NgxModalDraggableDirective;
  @Input() bsModalRef: BsModalRef;
  @Input() theme: 'light' | 'dark' = 'light';
  constructor(
    ) {
  }

  ngOnInit(): void {
    log('modalDirective ngOnInit', this.modalDirective);
    if (this.expand) {
      this.expand = !isMobile();
    }
  }

  minimize() {
    log('modalDirective minimize', this.modalDirective);
    this.modalDirective.modalMinimize();
  }
}
